<script setup lang="ts">
import { odsNavigation, odsNavigationItem } from "omind-design-system/components/odsNavigation"
import { isActiveRoute, isExactActiveRoute } from "@/router";
import { getClientListRouteLocation } from "@/domains/-coachee/-list/routes";
import { getGroupToolsRouteLocation } from "@/domains/-group-tools/routes";
import {getEventsRouteLocation, getGlossaryRouteLocation, getResourcesRouteLocation} from "@/domains/-community/routes";
import {useSessionStore} from "@/domains/-session/stores/useSessionStore"
import { resetCoacheesListQuery } from '@/domains/-session/functions/coacheesListQuery.ts';

const SESSION = useSessionStore()

</script>

<template>  
    <odsNavigation>
        <!-- <odsNavigationItem
            :icon="'space_dashboard'"
            :label="$t('navigation.dashboard')"
            :to="getClientListRouteLocation(1) as object"
        /> -->
        <odsNavigationItem
            :icon="'group'"
            :label="$t('navigation.clients')"
            :to="getClientListRouteLocation(SESSION.wsp?.workspace.id!,undefined,true) as object"
        />
        <odsNavigationItem
            :icon="'analytics'"
            :label="$t('navigation.group_analysis')"
            :to="getGroupToolsRouteLocation(SESSION.wsp?.workspace.id!) as object"
        />
        <div class="separator"></div>
        <odsNavigationItem
            :icon="'handshake'"
            :label="$t('navigation.community')"
            :group="true"
        >
            <odsNavigationItem
                :label="$t('navigation.community_events')"
                :to="getEventsRouteLocation(SESSION.wsp?.workspace.id!) as object"
            />
            <odsNavigationItem
                :label="$t('navigation.community_news')"
                :to="getEventsRouteLocation(SESSION.wsp?.workspace.id!,'#news') as object"
            />
            <odsNavigationItem
                :label="$t('navigation.community_resources')"
                :to="getResourcesRouteLocation(SESSION.wsp?.workspace.id!) as object"
            />
            <odsNavigationItem
                :label="$t('navigation.community_glossary')"
                :to="getGlossaryRouteLocation(SESSION.wsp?.workspace.id!) as object"
            />
        </odsNavigationItem>
        
        <!-- <odsNavigationItem
            :icon="'handshake'"
            :label="$t('navigation.community')"
            :to="getCommunityRouteLocation(SESSION.wsp?.workspace.id!) as object"
        /> -->
        <!-- <odsNavigationItem
            :icon="'contacts'"
            :label="$t('navigation.glossary')"
            :to="getGlossaryRouteLocation(SESSION.wsp?.workspace.id!) as object"
        /> -->
    </odsNavigation>
</template>

<style lang="scss">
    .ods-navigation{
        .separator{
            width: 100%;
            height: 0.0625rem;
            opacity: 0.2;
            background: #FFF;
        }
    }
</style>